import { createFileRoute } from '@tanstack/react-router'
import { ModelOperationsPage } from 'pages/modelOperations/ModelOperationsPage'
import { modelOperationsSearchParams } from 'routes/model-operations/-searchParams'

const RouteComponent = () => {
  const search = Route.useSearch()
  return <ModelOperationsPage siteId={search.siteId ?? null} search={search} />
}

export const Route = createFileRoute('/model-operations/')({
  component: RouteComponent,
  validateSearch: modelOperationsSearchParams,
  staticData: {
    title: 'Model Operations',
    layout: {
      enableScrolling: false,
    },
  },
})
